import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Contact Us", path: "/contact" },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center gap-4">
            <div className="relative">
              <div className="absolute inset-0  rounded-xl blur-sm opacity-70"></div>
              <img
                src="/img/logo2.png"
                alt="Stash Masters Logo"
                className="h-14 w-auto relative z-10 drop-shadow-md"
              />
            </div>
            <NavLink to="/" className="text-2xl font-bold  bg-clip-text">
              Stash Masters
            </NavLink>
          </div>

          {/* Desktop Navigation */}
          <ul className="hidden lg:flex items-center gap-1">
            {navLinks.map((link, index) => (
              <li key={link.name}>
                <NavLink
                  to={link.path}
                  className={({ isActive }) =>
                    `relative px-6 py-3 text-sm font-semibold transition-all duration-300 group
                    ${
                      isActive
                        ? "text-primary"
                        : "text-gray-700 hover:text-primary"
                    }`
                  }
                >
                  <span className="relative z-10">{link.name}</span>
                  {({ isActive }) =>
                    isActive && (
                      <span className="absolute inset-0 bg-gradient-to-r from-primary/10 to-accent/10 rounded-lg"></span>
                    )
                  }
                  <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-gradient-to-r from-primary to-accent transition-all duration-300 group-hover:w-4/5 group-hover:left-1/2 group-hover:-translate-x-1/2"></span>
                </NavLink>
              </li>
            ))}
          </ul>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <a
              href="http://wa.me/264852000821"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-gradient-to-r from-primary to-accent text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            >
              Get Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden relative w-10 h-10 focus:outline-none group"
            aria-label="Toggle menu"
          >
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <span
                className={`block w-6 h-0.5 bg-gray-800 rounded-full transition-all duration-300 ${
                  isMenuOpen ? "rotate-45 translate-y-0" : "-translate-y-2"
                }`}
              ></span>
              <span
                className={`block w-6 h-0.5 bg-gray-800 rounded-full transition-all duration-300 ${
                  isMenuOpen ? "opacity-0" : "opacity-100"
                }`}
              ></span>
              <span
                className={`block w-6 h-0.5 bg-gray-800 rounded-full transition-all duration-300 ${
                  isMenuOpen ? "-rotate-45 translate-y-0" : "translate-y-2"
                }`}
              ></span>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-500 ease-in-out ${
            isMenuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="py-6 px-4 bg-white border-t border-gray-100 rounded-b-2xl shadow-lg">
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <NavLink
                    to={link.path}
                    className={({ isActive }) =>
                      `block px-4 py-3 rounded-lg text-lg font-medium transition-all duration-300
                      ${
                        isActive
                          ? "bg-gradient-to-r from-primary/10 to-accent/10 text-primary border-l-4 border-primary"
                          : "text-gray-700 hover:bg-gray-50 hover:pl-6"
                      }`
                    }
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.name}
                  </NavLink>
                </li>
              ))}
              <li className="pt-4">
                <a
                  href="http://wa.me/264852000821"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-3 bg-gradient-to-r from-primary to-accent text-white font-semibold text-center rounded-lg shadow hover:shadow-md transition-shadow"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Get Quote on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
